export default __webpack_public_path__ + "static/media/home-track-mobile-yellow.ade2460b.svg";